export const getActionTypeFromTarget = (target: string): string => {
  if (target.startsWith('tel:')) {
    return 'phoneNumber';
  }

  if (target.startsWith('mailto:')) {
    return 'emailAddress';
  }

  if (target.startsWith('/articles/')) {
    return 'article';
  }

  if (target.startsWith('/pdf/')) {
    return 'pdf';
  }

  return 'url';
};
